import Icon from '../ui/Icon.jsx';
import { Money } from '../ui/Primitives.jsx';
import { ScoreRing } from '../ui/Charts.jsx';
import { toneClass } from '../../lib/format.js';

// The overlay used to open on the company name, a dotted meta line, and then a
// data-reliability banner in the largest space on screen. Reliability is how
// much to trust the answer, not the answer; it belongs beside the verdict, not
// above it. This puts the verdict, the score and the one-line reason first.

export default function ReportHeader({ report, symbol, price, onClose }) {
  const d = report?.decision;
  const r = report?.reliability;
  const tone = d ? toneClass(d.tone) : null;

  return (
    <>
      {/* Only the identity bar is pinned. With the verdict inside it the
          sticky block ate most of a phone screen and left no room to read. */}
      <div className="rhead">
        <div className="rhead-bar">
          <div className="rhead-id">
            <span className="rhead-name">{report?.identity.name ?? symbol}</span>
            <span className="rhead-tags">
              <span className="rhead-ticker">{report?.identity.ticker ?? symbol}</span>
              {report?.identity.sector && <span className="chip">{report.identity.sector}</span>}
              {report && <span className="chip">{report.holdingYears}y view</span>}
            </span>
          </div>

          <div className="rhead-right">
            {price?.available && (
              <div className="rhead-price">
                <span className="rhead-price-v"><Money value={price.value} /></span>
                <span className="rhead-price-l">last close</span>
              </div>
            )}
            <button className="close-btn" aria-label="Close report" onClick={onClose}>
              <Icon name="close" />
            </button>
          </div>
        </div>
      </div>

      {d && (
        <div className="rverdict">
          <div className={`verdict ${tone}`}>
            <div className="verdict-main">
              {d.score !== null && d.score !== undefined ? (
                <ScoreRing value={d.score} tone={tone} />
              ) : (
                <span className="verdict-noscore"><Icon name="info" /></span>
              )}
              <div className="verdict-body">
                <div className="verdict-label">{d.label}</div>
                <p className="verdict-headline">{d.headline}</p>
              </div>
            </div>
            {r && (
              <div className={`verdict-trust ${r.tone}`} title={r.advice}>
                <Icon name={r.level === 'HIGH' || r.level === 'MODERATE' ? 'check' : 'alert'} />
                <span>
                  <strong>{r.confirmedCount} of {r.totalSections}</strong> sections confirmed
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
